<svg id="svg_icons">
  <g id="profile" box="22 24">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.695.008c.203-.01.407-.01.61 0 .785.04 1.508.272 2.314.654.784.372 1.695.91 2.848 1.59l.066.038c1.153.68 2.064 1.217 2.771 1.725.727.522 1.286 1.044 1.712 1.719.11.175.213.355.305.54.36.714.523 1.47.602 2.373.077.88.077 1.955.077 3.314v.078c0 1.36 0 2.434-.077 3.314-.079.903-.243 1.659-.602 2.373a6.319 6.319 0 0 1-.305.54c-.52.822-1.238 1.42-2.215 2.064-.62.408-1.376.854-2.285 1.39l-.049.029c-1.153.68-2.064 1.217-2.848 1.589-.806.381-1.529.614-2.314.654-.203.01-.407.01-.61 0-.785-.04-1.508-.273-2.314-.654-.784-.372-1.695-.91-2.848-1.59l-.048-.028c-.9-.53-1.65-.973-2.267-1.378-.987-.648-1.712-1.249-2.234-2.076a6.322 6.322 0 0 1-.305-.54c-.36-.714-.523-1.47-.602-2.373C0 14.473 0 13.398 0 12.039v-.078c0-1.36 0-2.434.077-3.314.079-.903.243-1.659.602-2.373.092-.185.194-.365.305-.54.426-.675.985-1.197 1.712-1.719.707-.508 1.618-1.045 2.771-1.725l.066-.039C6.686 1.571 7.597 1.034 8.38.662 9.187.28 9.91.048 10.695.008Zm.53 1.638c-.15-.008-.3-.008-.45 0-.507.025-1.02.173-1.718.504-.711.337-1.561.837-2.754 1.54-1.193.704-2.042 1.206-2.684 1.667-.63.451-1.011.831-1.286 1.266-.082.13-.157.263-.226.4-.231.46-.362.988-.43 1.77-.07.798-.071 1.8-.071 3.207 0 1.407 0 2.409.07 3.207.069.782.2 1.31.431 1.77.069.137.144.27.226.4.219.347.505.658.931.998.843-1.675 2.552-2.822 4.525-2.822h6.422c1.973 0 3.682 1.147 4.525 2.822.426-.34.712-.651.931-.998.082-.13.157-.263.226-.4.231-.46.362-.988.43-1.77.07-.798.071-1.8.071-3.207 0-1.407 0-2.409-.07-3.207-.069-.782-.2-1.31-.431-1.77a4.679 4.679 0 0 0-.226-.4c-.275-.435-.657-.815-1.286-1.266-.642-.461-1.49-.963-2.684-1.666-1.193-.704-2.042-1.204-2.754-1.541-.698-.33-1.211-.479-1.717-.504Z"
      fill="#fff"
    />
    <circle cx="11" cy="10" r="4" fill="#fff" />
  </g>
  <g id="microphone" box="54 54">
    <path
      d="M31 19a4 4 0 0 0-8 0v8a4 4 0 0 0 8 0v-8Z"
      stroke="#8994BB"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19 27a8 8 0 0 0 16 0M27 35v4.5M22.5 39.5h9"
      stroke="#8994BB"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
  <g id="video_camera" box="54 54">
    <path
      d="M30 19H16a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V21a2 2 0 0 0-2-2ZM40 21v12l-7-6 7-6Z"
      stroke="#8994BB"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
  <g id="display" box="54 54">
    <path
      d="M41 35V16H13v19h28ZM13 31h28M23 36l-2 4h12l-2-4"
      stroke="#8994BB"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
  <g id="add_user" box="54 54">
    <path
      d="M23 27a5 5 0 1 0 0-10 5 5 0 0 0 0 10ZM18.5 30h9c1.2 0 2.34.5 3.18 1.37a4.76 4.76 0 0 1 1.32 3.3V37H14v-2.33c0-1.24.47-2.43 1.32-3.3A4.42 4.42 0 0 1 18.5 30ZM36 21.76v8.48M40.24 26h-8.49"
      stroke="#8994BB"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
  <g id="screen_cast2" box="54 54">
    <path
      d="M13.5 31.5A4.5 4.5 0 0 1 18 36M13.5 27a9 9 0 0 1 9 9"
      stroke="#8994BB"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M13.5 22.5V18h27v18H27" stroke="#8994BB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </g>
  <g id="screen_cast" box="54 54">
    <path
      d="M14 23.5V18h26v18H27M18.99 27v8.97M23.48 31.49H14.5"
      stroke="#8994BB"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
  <g id="settings" box="54 54">
    <path
      d="m24.12 18.42.46-3.42h4.84l.46 3.42c1 .39 1.92.97 2.72 1.7l2.98-1.26L38 23.3l-2.52 1.95c.2 1.13.2 2.29 0 3.42L38 30.75l-2.42 4.44-2.98-1.26c-.4.36-.83.68-1.29.95-.45.29-.93.52-1.43.7L29.42 39h-4.84l-.46-3.42c-1-.39-1.92-.97-2.73-1.7l-2.97 1.26L16 30.7l2.52-2.03a9.62 9.62 0 0 1 0-3.42L16 23.2l2.42-4.44 2.97 1.26a7.4 7.4 0 0 1 2.73-1.6Z"
      stroke="#8994BB"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M27 31a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
      stroke="#8994BB"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
  <g id="arrow_left" box="7 12">
    <path d="M6 11 1 6l5-5" stroke="#8994BB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </g>
  <g id="arrow_right" box="7 12">
    <path d="m1 1 5 5-5 5" stroke="#8994BB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </g>
  <g id="camera" box="13 8">
    <rect width="9" height="8" rx="1" fill="#fff" />
    <path
      d="M10 4.634V3.366a1 1 0 0 1 .486-.857l1.757-1.055a.5.5 0 0 1 .757.43v4.233a.5.5 0 0 1-.757.429L10.485 5.49A1 1 0 0 1 10 4.634Z"
      fill="#fff"
    />
  </g>
  <g id="eye" box="16 16">
    <path
      d="M14.973 7.838C13.977 4.944 11.175 3 8 3S2.023 4.944 1.027 7.838a.503.503 0 0 0 0 .324C2.023 11.056 4.825 13 8 13s5.977-1.944 6.973-4.838a.503.503 0 0 0 0-.325ZM8 11c-1.654 0-3-1.345-3-3 0-1.654 1.346-3 3-3 1.655 0 3 1.346 3 3 0 1.655-1.345 3-3 3Z"
      fill="#fff"
    />
  </g>
  <g id="eye_disabled" box="16 16">
    <path
      d="M10.361 12.482a.093.093 0 0 1-.037.153c-3.85 1.233-8.016-.752-9.297-4.471a.51.51 0 0 1 0-.327A7.004 7.004 0 0 1 2.821 5.05a.078.078 0 0 1 .109.002l2.151 2.15c.015.016.02.037.015.057-.558 2.173 1.474 4.197 3.638 3.647a.065.065 0 0 1 .066.016l1.561 1.56ZM12.34 11.633a7.05 7.05 0 0 0 2.633-3.47.503.503 0 0 0 0-.325C13.977 4.944 11.175 3 8 3c-1.24 0-2.42.299-3.46.833L1.854 1.146a.5.5 0 1 0-.707.708l13 13a.5.5 0 1 0 .707-.707l-2.514-2.514ZM8 5c1.655 0 3 1.346 3 3a2.98 2.98 0 0 1-.557 1.736L6.265 5.556A2.98 2.98 0 0 1 8 5Z"
      fill="#fff"
    />
  </g>
  <g id="volume" box="11 11">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.441 1.86c-.194-.185-.503-.135-.652.089a.5.5 0 0 0 .079.63A4.11 4.11 0 0 1 10.083 5.5a4.11 4.11 0 0 1-1.215 2.922.5.5 0 0 0-.079.63c.15.223.458.273.652.088A5.018 5.018 0 0 0 11 5.5c0-1.432-.6-2.722-1.559-3.64ZM8.416 3.44c-.181-.215-.51-.169-.666.065-.127.19-.094.442.044.625a2.267 2.267 0 0 1 0 2.742c-.138.182-.171.434-.044.624.156.234.485.28.666.064a3.193 3.193 0 0 0 .75-2.06 3.19 3.19 0 0 0-.75-2.06ZM5.5.459c-.54 0-.703.314-.703.314S3.394 2.313 2.428 2.993a1.209 1.209 0 0 1-.718.215H.917A.917.917 0 0 0 0 4.125v2.75c0 .506.41.917.917.917h.793c.345 0 .54.101.718.215.966.68 2.369 2.222 2.369 2.222s.164.313.703.313c.506 0 .917-.41.917-.917v-8.25A.917.917 0 0 0 5.5.458Z"
      fill="#fff"
    />
  </g>
  <g id="volume_disabled" box="11 11">
    <path
      d="M9.4 1.9c-.2-.2-.5-.2-.6 0-.1.2-.1.5.1.7.8.7 1.2 1.8 1.2 2.9 0 1.1-.5 2.2-1.2 2.9-.2.2-.2.5-.1.7.1.2.5.3.7.1 1-.9 1.6-2.2 1.6-3.6-.1-1.5-.7-2.8-1.7-3.7zm-1 1.5c-.2-.2-.5-.1-.7.1-.1.2-.1.4 0 .6.4.4.6.9.6 1.4 0 .5-.2 1-.5 1.4-.1.2-.2.4 0 .6.2.2.5.3.7.1.4-.6.7-1.3.7-2.1S8.9 4 8.4 3.4zM5.5.5c-.5 0-.7.3-.7.3S3.4 2.3 2.4 3c-.1.1-.3.2-.7.2H.9c-.5 0-.9.4-.9.9v2.8c0 .5.4.9.9.9h.8c.3 0 .5.1.7.2 1 .7 2.4 2.2 2.4 2.2s.2.3.7.3c.5 0 .9-.4.9-.9V1.4c0-.5-.4-.9-.9-.9z"
      style="fill-rule: evenodd; clip-rule: evenodd; fill: #cf3f3f"
    />
    <path style="fill: #cf3f3f; stroke: #f54141; stroke-width: 0.75; stroke-miterlimit: 10" d="m.3.3 10.5 10.4" />
  </g>
  <g id="volume_slider" box="10 11">
    <rect width="10" height="11" rx="2" fill="url(#a)" />
    <rect x="8" y="2" width="1" height="6" rx=".5" transform="rotate(90 8 2)" fill="#fff" />
    <rect x="8" y="4" width="1" height="6" rx=".5" transform="rotate(90 8 4)" fill="#fff" />
    <rect x="8" y="6" width="1" height="6" rx=".5" transform="rotate(90 8 6)" fill="#fff" />
    <rect x="8" y="8" width="1" height="6" rx=".5" transform="rotate(90 8 8)" fill="#fff" />
    <defs>
      <linearGradient id="a" x1="0" y1="5.5" x2="10" y2="5.5" gradientUnits="userSpaceOnUse">
        <stop offset=".427" stop-color="#FF7F00" />
        <stop offset="1" stop-color="#EEA823" />
      </linearGradient>
    </defs>
  </g>
  <g id="volume_bar" box="188 5">
    <rect width="188" height="5" rx="2.5" fill="#989898" />
    <path
      fill="#7A7A7A"
      d="M8 0h1v5H8zM62 0h1v5h-1zM116 0h1v5h-1zM35 0h1v5h-1zM89 0h1v5h-1zM143 0h1v5h-1zM170 0h1v5h-1zM17 0h1v5h-1zM71 0h1v5h-1zM125 0h1v5h-1zM44 0h1v5h-1zM98 0h1v5h-1zM152 0h1v5h-1zM179 0h1v5h-1zM26 0h1v5h-1zM80 0h1v5h-1zM134 0h1v5h-1zM53 0h1v5h-1zM107 0h1v5h-1zM161 0h1v5h-1z"
    />
  </g>
  <g id="connection_good" box="24 24">
    <path
      d="M7 14H5v2h2v-2ZM11 12H9v4h2v-4ZM15 10h-2v6h2v-6ZM19 8h-2v8h2V8Z"
      fill="#5FCC7E"
      stroke="#2F9D4E"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
  <g id="connection_normal" box="24 24">
    <path
      d="M7 14H5v2h2v-2ZM11 12H9v4h2v-4ZM15 10h-2v6h2v-6ZM19 8h-2v8h2V8Z"
      fill="#E2D451"
      stroke="#DE9A34"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
  <g id="close" box="14 14">
    <path
      d="m8.54 7 5.24-5.23a.76.76 0 0 0 0-1.09l-.46-.46a.76.76 0 0 0-.54-.22c-.2 0-.4.08-.55.22L7 5.46 1.77.22A.76.76 0 0 0 1.22 0c-.2 0-.4.08-.54.22L.22.68c-.3.3-.3.79 0 1.09L5.46 7 .22 12.23a.76.76 0 0 0-.22.55c0 .2.08.4.22.54l.46.46c.15.14.34.22.54.22s.4-.08.55-.22L7 8.54l5.23 5.24c.15.14.34.22.55.22.2 0 .4-.08.54-.22l.46-.46a.76.76 0 0 0 .22-.54c0-.2-.08-.4-.22-.55L8.54 7Z"
      fill="#959595"
    />
  </g>
  <g id="close-dark" box="14 14">
    <path
      d="m8.54 7 5.24-5.23a.76.76 0 0 0 0-1.09l-.46-.46a.76.76 0 0 0-.54-.22c-.2 0-.4.08-.55.22L7 5.46 1.77.22A.76.76 0 0 0 1.22 0c-.2 0-.4.08-.54.22L.22.68c-.3.3-.3.79 0 1.09L5.46 7 .22 12.23a.76.76 0 0 0-.22.55c0 .2.08.4.22.54l.46.46c.15.14.34.22.54.22s.4-.08.55-.22L7 8.54l5.23 5.24c.15.14.34.22.55.22.2 0 .4-.08.54-.22l.46-.46a.76.76 0 0 0 .22-.54c0-.2-.08-.4-.22-.55L8.54 7Z"
      fill="#5b637d"
    />
  </g>
  <g id="info" box="13 13">
    <circle cx="6.5" cy="6.5" r="6" fill="#fff" stroke="#C4C4C4" />
    <rect x="6" y="5" width="1" height="5" rx=".5" fill="#C4C4C4" />
    <rect x="6" y="3" width="1" height="1" rx=".5" fill="#C4C4C4" />
  </g>
  <g id="volume_orange" box="15 15">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.87 2.54c-.26-.26-.68-.19-.88.12a.68.68 0 0 0 .1.86 5.6 5.6 0 0 1 0 7.96.68.68 0 0 0-.1.86c.2.3.62.38.88.12a6.84 6.84 0 0 0 0-9.92Zm-1.4 2.15c-.24-.3-.69-.23-.9.09-.18.26-.13.6.06.85a3.1 3.1 0 0 1 0 3.74c-.19.25-.24.6-.06.85.21.32.66.38.9.09a4.35 4.35 0 0 0 0-5.62ZM7.5.62c-.74 0-.96.43-.96.43s-1.91 2.1-3.23 3.03c-.24.16-.5.3-.98.3H1.25C.56 4.38 0 4.92 0 5.63v3.75c0 .68.56 1.24 1.25 1.24h1.08c.47 0 .74.14.98.3 1.32.93 3.23 3.03 3.23 3.03s.22.43.96.43c.69 0 1.25-.56 1.25-1.26V1.88c0-.7-.56-1.25-1.25-1.25Z"
      fill="url(#volume_orange_a)"
    />
    <defs>
      <linearGradient id="volume_orange_a" x1="0" y1="7.5" x2="15" y2="7.5" gradientUnits="userSpaceOnUse">
        <stop offset=".43" stop-color="#FF7F00" />
        <stop offset="1" stop-color="#EEA823" />
      </linearGradient>
    </defs>
  </g>
  <g id="home" box="18 18">
    <path
      d="M17.63 8.85 9.45.2A.63.63 0 0 0 9 0a.6.6 0 0 0-.45.2L.37 8.85c-.23.25-.37.6-.37.96 0 .74.57 1.34 1.27 1.34h.86v6.18c0 .37.29.67.64.67H7v-6h4v6h4.23c.35 0 .64-.3.64-.67v-6.18h.86c.34 0 .66-.14.9-.4.5-.52.5-1.37 0-1.9Z"
      fill="url(#2)"
    />
    <path
      d="M17.63 8.85 9.45.2A.63.63 0 0 0 9 0a.6.6 0 0 0-.45.2L.37 8.85c-.23.25-.37.6-.37.96 0 .74.57 1.34 1.27 1.34h.86v6.18c0 .37.29.67.64.67H7v-6h4v6h4.23c.35 0 .64-.3.64-.67v-6.18h.86c.34 0 .66-.14.9-.4.5-.52.5-1.37 0-1.9Z"
      fill="#fff"
    />
    <defs>
      <linearGradient id="2" x1="0" y1="9" x2="18" y2="9" gradientUnits="userSpaceOnUse">
        <stop offset=".43" stop-color="#FF7F00" />
        <stop offset="1" stop-color="#EEA823" />
      </linearGradient>
    </defs>
  </g>
  <g id="dashboard" box="18 18">
    <path
      d="M6 18H2a2 2 0 0 1-2-2V2C0 .9.9 0 2 0h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2Zm6 0h4a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5c0 1.1.9 2 2 2Zm6-13V2a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v3c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2Z"
      fill="#fff"
    />
  </g>
  <g id="schedule" box="30 29">
    <path
      d="M0 7.95c0-1.89 0-2.83.59-3.42.58-.58 1.52-.58 3.41-.58h22c1.89 0 2.83 0 3.41.58.59.59.59 1.53.59 3.42v2.37c0 .47 0 .7-.15.85-.14.15-.38.15-.85.15H1c-.47 0-.7 0-.85-.15-.15-.15-.15-.38-.15-.85V7.95Z"
      fill="#fff"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 25c0 1.89 0 2.83.59 3.41C1.17 29 2.1 29 4 29h22c1.89 0 2.83 0 3.41-.59.59-.58.59-1.52.59-3.41v-9.74c0-.47 0-.7-.15-.85-.14-.15-.38-.15-.85-.15H1c-.47 0-.7 0-.85.15-.15.15-.15.38-.15.85V25Zm7.5-6.29c0-.47 0-.7.08-.88a1 1 0 0 1 .54-.54c.18-.08.41-.08.88-.08h3c.47 0 .7 0 .88.08.25.1.44.3.54.54.08.18.08.41.08.88 0 .47 0 .7-.08.88a1 1 0 0 1-.54.54c-.18.08-.41.08-.88.08H9c-.47 0-.7 0-.88-.08a1 1 0 0 1-.54-.54c-.08-.18-.08-.41-.08-.88Zm.08 5.01c-.08.19-.08.42-.08.89 0 .46 0 .7.08.88.1.24.3.44.54.54.18.08.41.08.88.08h3c.47 0 .7 0 .88-.08a1 1 0 0 0 .54-.54c.08-.19.08-.42.08-.88 0-.47 0-.7-.08-.89a1 1 0 0 0-.54-.54c-.18-.07-.41-.07-.88-.07H9c-.47 0-.7 0-.88.07a1 1 0 0 0-.54.54Zm8.92-5c0-.48 0-.7.08-.9a1 1 0 0 1 .54-.53c.18-.08.41-.08.88-.08h3c.47 0 .7 0 .88.08.25.1.44.3.54.54.08.18.08.41.08.88 0 .47 0 .7-.08.88a1 1 0 0 1-.54.54c-.18.08-.41.08-.88.08h-3c-.47 0-.7 0-.88-.08a1 1 0 0 1-.54-.54c-.08-.18-.08-.41-.08-.88Zm.08 5c-.08.19-.08.42-.08.89 0 .46 0 .7.08.88.1.24.3.44.54.54.18.08.41.08.88.08h3c.47 0 .7 0 .88-.08a1 1 0 0 0 .54-.54c.08-.19.08-.42.08-.88 0-.47 0-.7-.08-.89a1 1 0 0 0-.54-.54c-.18-.07-.41-.07-.88-.07h-3c-.47 0-.7 0-.88.07a1 1 0 0 0-.54.54Z"
      fill="#fff"
    />
    <path d="M7.5 1v4.42M22.5 1v4.42" stroke="#fff" stroke-width="2" stroke-linecap="round" />
  </g>
  <g id="video" box="56 56">
    <rect width="56" height="56" rx="28" fill="#F4F5F7" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.33 18.67A2.67 2.67 0 0 1 16 16h24a2.67 2.67 0 0 1 2.67 2.67v18.66A2.67 2.67 0 0 1 40 40H16a2.67 2.67 0 0 1-2.67-2.67V18.67zm5.34 2.66H16v-2.66h2.67v2.66zM16 26.67h2.67V24H16v2.67zM16 32h2.67v-2.67H16V32zm21.33 0H40v-2.67h-2.67V32zM40 26.67h-2.67V24H40v2.67zm-2.67-5.34H40v-2.66h-2.67v2.66zM32 28l-8-5.33v10.66L32 28zm-16 9.33h2.67v-2.66H16v2.66zm24 0h-2.67v-2.66H40v2.66z"
      fill="url(#video_a)"
    />
    <defs>
      <linearGradient id="video_a" x1="0" y1="7.5" x2="15" y2="7.5" gradientUnits="userSpaceOnUse">
        <stop offset=".43" stop-color="#FF7F00" />
        <stop offset="1" stop-color="#EEA823" />
      </linearGradient>
    </defs>
  </g>
  <g id="music" box="56 56">
    <rect width="56" height="56" rx="28" fill="#F4F5F7" />
    <path
      d="M38.67 14.67h-16A2.67 2.67 0 0 0 20 17.33v16C20 34.8 21.2 36 22.67 36h16c1.46 0 2.66-1.2 2.66-2.67v-16c0-1.46-1.2-2.66-2.66-2.66zM36 21.33h-4v7.34a3.33 3.33 0 0 1-6.67 0 3.33 3.33 0 0 1 3.34-3.34c.76 0 1.44.26 2 .68v-7.34H36v2.66zM17.33 20h-2.66v18.67c0 1.46 1.2 2.66 2.66 2.66H36v-2.66H17.33V20z"
      fill="url(#music_a)"
    />
    <defs>
      <linearGradient id="music_a" x1="0" y1="7.5" x2="15" y2="7.5" gradientUnits="userSpaceOnUse">
        <stop offset=".43" stop-color="#FF7F00" />
        <stop offset="1" stop-color="#EEA823" />
      </linearGradient>
    </defs>
  </g>
  <g id="video_play" box="11 7">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11 0H0v7h11V0ZM7.25 3.933a.5.5 0 0 0 0-.866L5 1.767a.5.5 0 0 0-.75.434v2.598a.5.5 0 0 0 .75.433l2.25-1.299Z"
      fill="#fff"
    />
  </g>
  <g id="camera_down" box="13 10">
    <path d="M12 8V1H1v7h11Z" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" />
    <path d="m4.167 7-.902 2.319A.5.5 0 0 0 3.73 10h5.538a.5.5 0 0 0 .466-.681L8.833 7" fill="#fff" />
    <path fill="#fff" d="M1 1h11v7H1z" />
  </g>
  <g id="options" box="2 10">
    <circle cx="1" cy="1" r="1" fill="#fff" />
    <circle cx="1" cy="5" r="1" fill="#fff" />
    <circle cx="1" cy="9" r="1" fill="#fff" />
  </g>
  <g id="edit" box="10 10">
    <path
      d="M9.628 2.059 7.915.34A1.248 1.248 0 0 0 6.253.296L.628 5.942A1.256 1.256 0 0 0 .27 6.7L.003 9.316a.63.63 0 0 0 .385.637.623.623 0 0 0 .24.047h.056l2.606-.238c.286-.029.553-.155.756-.358L9.671 3.76a1.207 1.207 0 0 0-.043-1.7Zm-1.411 1.38L6.542 1.76l.504-.54L8.753 2.93l-.536.509Z"
    />
  </g>
  <g id="image" box="11 11">
    <path d="M3.385 3.808a1.551 1.551 0 1 1 3.102 0 1.551 1.551 0 0 1-3.102 0Z" fill="#353B50" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.474 0h.052c1.036 0 1.848 0 2.492.07.657.071 1.19.219 1.645.55.275.2.518.442.717.717.331.455.479.988.55 1.645.07.644.07 1.456.07 2.492v.03c0 .526 0 .993-.008 1.407-.026 1.215-.12 2.077-.612 2.752a3.24 3.24 0 0 1-.717.717c-.455.331-.988.479-1.645.55-.644.07-1.456.07-2.492.07h-.052c-1.036 0-1.848 0-2.492-.07-.657-.071-1.19-.219-1.645-.55a3.243 3.243 0 0 1-.718-.717C.29 9.208.141 8.675.07 8.018 0 7.374 0 6.562 0 5.526v-.052c0-1.036 0-1.848.07-2.492.071-.657.219-1.19.55-1.645.2-.275.442-.517.717-.718.455-.33.988-.478 1.645-.55C3.626 0 4.438 0 5.474 0Zm-2.4.911c-.586.063-.953.185-1.24.393a2.398 2.398 0 0 0-.53.53c-.208.287-.33.654-.393 1.24C.847 3.666.846 4.432.846 5.5c0 1.067 0 1.833.065 2.427.023.21.053.39.092.55.155-.298.284-.518.436-.706a3.244 3.244 0 0 1 2.449-1.197c.356-.008.736.068 1.356.192l.07.014c.098-.16.183-.29.273-.4a3.244 3.244 0 0 1 4.395-.599c.055.04.112.084.172.135V5.5c0-1.067 0-1.833-.065-2.427-.064-.585-.185-.952-.393-1.239a2.398 2.398 0 0 0-.53-.53c-.287-.208-.654-.33-1.24-.393C7.334.847 6.568.846 5.5.846c-1.067 0-1.833 0-2.427.065Z"
      fill="#353B50"
    />
  </g>
  <g id="delete" box="11 11">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M.928 1.26C.344 2.063.344 3.208.344 5.5c0 2.292 0 3.437.584 4.24.188.26.416.488.676.676.803.584 1.949.584 4.24.584 2.292 0 3.438 0 4.24-.584.26-.188.488-.416.677-.676.583-.803.583-1.949.583-4.24 0-2.292 0-3.437-.583-4.24a3.056 3.056 0 0 0-.676-.676C9.282 0 8.135 0 5.845 0 3.552 0 2.406 0 1.603.584c-.26.188-.488.416-.676.676Zm2.944 1.768a.458.458 0 1 0-.648.648l1.972 1.972-1.972 1.973a.458.458 0 1 0 .648.648l1.972-1.973L7.817 8.27a.458.458 0 0 0 .648-.648L6.492 5.648l1.973-1.972a.458.458 0 1 0-.648-.648L5.844 5 3.872 3.028Z"
      fill="#F93838"
    />
  </g>
  <g id="remove" box="14 14">
    <path
      d="M13.42 2.52h-2.34v-1.4C11.08.5 10.56 0 9.92 0H4.08c-.64 0-1.16.5-1.16 1.12v1.4H.58a.57.57 0 0 0-.58.56v.56c0 .08.07.14.15.14h1.1l.45 9.15c.03.6.54 1.07 1.16 1.07h8.28c.62 0 1.13-.47 1.16-1.07l.45-9.15h1.1c.08 0 .15-.06.15-.14v-.56a.57.57 0 0 0-.58-.56Zm-3.65 0H4.23V1.26h5.54v1.26Z"
    />
  </g>
  <g id="copy" box="24 24">
    <path
      d="M20 9h-9a2 2 0 0 0-2 2v9c0 1.1.9 2 2 2h9a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2Z"
      stroke="#717892"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
      stroke="#717892"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
  <g id="full_screen" box="24 24">
    <g opacity=".8" filter="url(#_full_screen)" stroke="#fff">
      <path d="M4.5.5h5v1h-5z" />
      <path d="M5.5.5v5h-1v-5zM19.5 15.5h-5v-1h5z" />
      <path d="M18.5 15.5v-5h1v5zM19.5.5v5h-1v-5z" />
      <path d="M19.5 1.5h-5v-1h5zM4.5 15.5v-5h1v5z" />
      <path d="M4.5 14.5h5v1h-5z" />
    </g>
    <defs>
      <filter
        id="_full_screen"
        x="0"
        y="0"
        width="24"
        height="24"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_554_17" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_554_17" result="shape" />
      </filter>
    </defs>
  </g>
  <g id="scale" box="12 12">
    <g clip-path="url(#_scale)">
      <path
        d="M11.5 12H8.3a.5.5 0 0 1 0-1h2.6V8.2a.5.5 0 0 1 1.1 0v3.2c0 .3-.2.5-.5.5ZM3.7 1H1.1v2.7a.5.5 0 0 1-1.1 0V.5C0 .2.2 0 .5 0h3.2a.5.5 0 0 1 0 1ZM11.5 4.3a.5.5 0 0 1-.6-.6V1.1H8.3a.5.5 0 0 1 0-1.1h3.2c.3 0 .5.2.5.5v3.2c0 .3-.2.6-.5.6ZM3.7 12H.5a.5.5 0 0 1-.5-.5V8.3a.5.5 0 0 1 1 0v2.6h2.7a.5.5 0 1 1 0 1.1Z"
      />
      <rect width="1.2" height="5" rx=".6" transform="scale(-1 1) rotate(-45 -5.4 15)" />
      <rect width="1" height="5" rx=".5" transform="scale(-1 1) rotate(-45 8.3 9.4)" />
    </g>
    <defs>
      <clipPath id="_scale">
        <path transform="matrix(1 0 0 -1 0 12)" d="M0 0h12v12H0z" />
      </clipPath>
    </defs>
  </g>
  <g id="main_screen" box="32 24">
    <svg width="32" height="24" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity=".8" filter="url(#_main_screen)">
        <path stroke="inherit" stroke-width="2" d="M5 1h22v14H5z" />
      </g>
      <defs>
        <filter
          id="_main_screen"
          x="0"
          y="0"
          width="32"
          height="24"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_554_18" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_554_18" result="shape" />
        </filter>
      </defs>
    </svg>
  </g>
  <g id="settings_menu_icon" box="20 20">
    <g clip-path="url(#_settings_menu_icon)" fill="#fff">
      <path
        d="M18.722 7.88h-.755a8.189 8.189 0 0 0-.835-2.014l.535-.535a1.278 1.278 0 0 0 0-1.807l-1.191-1.19a1.278 1.278 0 0 0-1.807 0l-.535.534a8.193 8.193 0 0 0-2.014-.835v-.755C12.12.572 11.548 0 10.842 0H9.158c-.705 0-1.277.572-1.277 1.278v.755c-.715.19-1.39.473-2.015.835l-.535-.534a1.278 1.278 0 0 0-1.807 0l-1.19 1.19a1.278 1.278 0 0 0 0 1.807l.534.535a8.19 8.19 0 0 0-.835 2.015h-.755C.572 7.88 0 8.453 0 9.158v1.684c0 .706.572 1.278 1.278 1.278h.755c.19.714.473 1.39.835 2.014l-.534.535a1.278 1.278 0 0 0 0 1.807l1.19 1.19a1.278 1.278 0 0 0 1.807 0l.535-.534c.624.362 1.3.645 2.015.835v.755c0 .706.572 1.278 1.277 1.278h1.684c.706 0 1.278-.572 1.278-1.278v-.755a8.192 8.192 0 0 0 2.014-.835l.535.535a1.278 1.278 0 0 0 1.807 0l1.19-1.191a1.277 1.277 0 0 0 0-1.807l-.534-.535a8.19 8.19 0 0 0 .835-2.014h.755c.706 0 1.278-.572 1.278-1.278V9.158c0-.705-.572-1.277-1.278-1.277ZM10 14.574A4.578 4.578 0 0 1 5.427 10 4.578 4.578 0 0 1 10 5.427 4.578 4.578 0 0 1 14.573 10 4.578 4.578 0 0 1 10 14.573Z"
      />
      <path
        d="M10 7.714A2.29 2.29 0 0 0 7.714 10 2.289 2.289 0 0 0 10 12.287 2.289 2.289 0 0 0 12.287 10 2.29 2.29 0 0 0 10 7.714Z"
      />
    </g>
    <defs>
      <clipPath id="_settings_menu_icon">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </g>
  <g id="logout" box="20 20">
    <g clip-path="url(#_logout)" fill="#fff">
      <path
        d="M19.936 8.849a.843.843 0 0 0-.18-.272l-2.5-2.5a.834.834 0 0 0-1.178 1.18l1.078 1.077H12.5a.833.833 0 1 0 0 1.666h4.655l-1.077 1.078a.832.832 0 1 0 1.178 1.178l2.5-2.5a.835.835 0 0 0 .18-.908Z"
      />
      <path
        d="M14.167 11.667a.833.833 0 0 0-.833.833v4.167H10V4.333a.834.834 0 0 0-.595-.798L2.5 1.667h10.834v4.166a.833.833 0 1 0 1.666 0v-5A.833.833 0 0 0 14.167 0H.834C.804 0 .777.013.748.016a.835.835 0 0 0-.353.123C.376.151.354.152.336.165.33.17.327.179.32.185A.826.826 0 0 0 .1.447C.087.47.085.493.075.518.05.58.02.641.01.712.005.738.013.76.012.784.012.802 0 .817 0 .833V17.5c0 .398.281.74.67.817l8.334 1.666a.833.833 0 0 0 .997-.817v-.833h4.166c.46 0 .833-.373.833-.833v-5a.833.833 0 0 0-.833-.833Z"
      />
    </g>
    <defs>
      <clipPath id="_logout"><path fill="#fff" d="M0 0h20v20H0z" /></clipPath>
    </defs>
  </g>
  <g id="reload" box="32 32">
    <svg fill="#fff" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fill="#fff"
          d="M0 16q0-2.784 1.088-5.312t2.912-4.384 4.384-2.912 5.344-1.088q2.784 0 5.312 1.088t4.384 2.912 2.912 4.384 1.088 5.312h2.304q0.736 0 1.28 0.416t0.8 1.024 0.16 1.28-0.64 1.184l-4.576 4.576q-0.672 0.672-1.6 0.672t-1.632-0.672l-4.576-4.576q-0.512-0.512-0.608-1.184t0.128-1.28 0.8-1.024 1.312-0.416h2.272q0-2.464-1.216-4.576t-3.328-3.328-4.576-1.216-4.608 1.216-3.328 3.328-1.216 4.576 1.216 4.608 3.328 3.328 4.608 1.216q1.728 0 3.36-0.64l3.424 3.392q-3.136 1.824-6.784 1.824-2.816 0-5.344-1.088t-4.384-2.912-2.912-4.384-1.088-5.344z"
        ></path>
      </g>
    </svg>
  </g>
  <g id="channel-icon" box="28 24">
    <path
      fill="#A0A7C0"
      d="M27 2.667a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v.667a1 1 0 0 0 1 1h26ZM27 8a1 1 0 0 0 1-1v-.667a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1V7a1 1 0 0 0 1 1h26Zm-14.273 5.333v-2.666H1a1 1 0 0 0-1 1v.666a1 1 0 0 0 1 1h11.727Zm2.546-2.666h11.454c.7 0 1.273.6 1.273 1.333v10.667C28 23.4 27.427 24 26.727 24H15.273c-.7 0-1.273-.6-1.273-1.333V12c0-.733.573-1.333 1.273-1.333ZM19.09 20l4.238-2.667-4.238-2.666V20Zm-6.364-1.333V16H1a1 1 0 0 0-1 1v.667a1 1 0 0 0 1 1h11.727Zm0 5.333v-2.667H1a1 1 0 0 0-1 1V23a1 1 0 0 0 1 1h11.727Z"
    />
  </g>
  <g id="refresh" box="20 20">
    <path
      fill="url(#refresh_icon_1)"
      d="m18.18 11.48-1.6-2.28A.83.83 0 0 0 15.4 9l-2.27 1.61a.83.83 0 1 0 .96 1.36l.76-.53A5.03 5.03 0 0 1 10 15.08a5.02 5.02 0 0 1-3.84-1.78.84.84 0 0 0-1.27 1.08A6.68 6.68 0 0 0 10 16.74a6.77 6.77 0 0 0 6.45-4.82l.37.52a.83.83 0 1 0 1.36-.96Z"
    />
    <path
      fill="url(#refresh_icon_2)"
      d="M7.06 8.22a.83.83 0 0 0-1.16-.2l-.76.54A5.03 5.03 0 0 1 10 4.92c1.48 0 2.88.65 3.84 1.78a.83.83 0 0 0 1.27-1.08A6.68 6.68 0 0 0 10 3.26a6.77 6.77 0 0 0-6.45 4.82l-.37-.52a.83.83 0 1 0-1.36.96l1.6 2.28a.83.83 0 0 0 1.17.2l2.27-1.61a.83.83 0 0 0 .2-1.17Z"
    />
    <defs>
      <linearGradient id="refresh_icon_1" x1="4.69" x2="18.33" y1="12.8" y2="12.8" gradientUnits="userSpaceOnUse">
        <stop offset=".43" stop-color="#FF7F00" />
        <stop offset="1" stop-color="#EEA823" />
      </linearGradient>
      <linearGradient id="refresh_icon_2" x1="1.67" x2="15.31" y1="7.2" y2="7.2" gradientUnits="userSpaceOnUse">
        <stop offset=".43" stop-color="#FF7F00" />
        <stop offset="1" stop-color="#EEA823" />
      </linearGradient>
    </defs>
  </g>
  <g id="edit-btn" box="14 14">
    <path
      fill="#8F939C"
      d="m13.48 2.88-2.4-2.4A1.75 1.75 0 0 0 8.75.4L.88 8.31c-.28.3-.46.67-.5 1.07L0 13.04a.88.88 0 0 0 .88.96h.08l3.65-.33c.4-.04.77-.22 1.05-.5l7.88-7.9a1.69 1.69 0 0 0-.06-2.39ZM11.5 4.82 9.16 2.46l.7-.75 2.4 2.4-.76.7Z"
    />
  </g>
  <g id="remove-btn" box="14 14">
    <path
      fill="#8F939C"
      d="M13.42 2.52h-2.34v-1.4C11.08.5 10.56 0 9.92 0H4.08c-.64 0-1.16.5-1.16 1.12v1.4H.58a.57.57 0 0 0-.58.56v.56c0 .08.07.14.15.14h1.1l.45 9.15c.03.6.54 1.07 1.16 1.07h8.28c.62 0 1.13-.47 1.16-1.07l.45-9.15h1.1c.08 0 .15-.06.15-.14v-.56a.57.57 0 0 0-.58-.56Zm-3.65 0H4.23V1.26h5.54v1.26Z"
    />
  </g>
  <g id="add-btn" box="18 18">
    <circle cx="9" cy="9" r="9" fill="url(#add-icon)" />
    <path fill="#fff" d="M8.06 12.71v-2.66H5.48V8.33h2.58V5.69h1.93v2.64h2.55v1.72H10v2.66H8.06Z" />
    <defs>
      <linearGradient id="add-icon" x1="0" x2="18" y1="9" y2="9" gradientUnits="userSpaceOnUse">
        <stop offset=".43" stop-color="#FF7F00" />
        <stop offset="1" stop-color="#EEA823" />
      </linearGradient>
    </defs>
  </g>
  <g id="mute" box="16 16">
    <g fill="#8994BB" clip-path="url(#mute-icon)">
      <path
        d="M3.9 8c0 2.2 1.7 4 3.8 4 .81 0 1.57-.27 2.2-.74l.44.48c-.73.58-1.65.93-2.65.93A4.55 4.55 0 0 1 3.27 8a.65.65 0 0 0-.64-.67c-.35 0-.63.3-.63.67a5.9 5.9 0 0 0 5.06 5.96V14.67H5.8c-.35 0-.64.3-.64.66 0 .37.29.67.64.67h3.8c.34 0 .62-.3.62-.67a.65.65 0 0 0-.63-.66H8.33V13.96c1.1-.12 2.1-.58 2.92-1.27l1.67 1.76c.25.26.65.26.9 0a.7.7 0 0 0 0-.94L3.07 2.2a.61.61 0 0 0-.9 0 .7.7 0 0 0 0 .94l1.72 1.8V8ZM4.32 2.17l6.91 7.28c.17-.45.26-.94.26-1.45V4c0-2.2-1.7-4-3.8-4-1.47 0-2.74.88-3.37 2.17ZM11.71 9.96l.94.99c.47-.87.74-1.88.74-2.95a.65.65 0 0 0-.64-.67c-.35 0-.63.3-.63.67 0 .7-.15 1.36-.4 1.96Z"
      />
    </g>
    <defs>
      <clipPath id="mute-icon"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath>
    </defs>
  </g>
  <g id="plus" box="18 18">
    <circle cx="9" cy="9" r="9" fill="url(#paint0_linear_1517_2)" />
    <path fill="#fff" d="M8.058 12.71v-2.655h-2.58V8.33h2.58V5.69h1.935v2.64h2.55v1.725h-2.55v2.655H8.058Z" />
    <defs>
      <linearGradient id="paint0_linear_1517_2" x1="0" x2="18" y1="9" y2="9" gradientUnits="userSpaceOnUse">
        <stop offset=".427" stop-color="#FF7F00" />
        <stop offset="1" stop-color="#EEA823" />
      </linearGradient>
    </defs>
  </g>
  <g id="caption-close" box="18 18">
    <circle cx="9" cy="9" r="9" fill="url(#paint0_linear_0_1)" />
    <path
      fill="#fff"
      d="m9.88 9 3-3a.44.44 0 0 0 0-.61l-.27-.26a.43.43 0 0 0-.3-.13.43.43 0 0 0-.32.13L9 8.12l-3-3A.43.43 0 0 0 5.7 5a.43.43 0 0 0-.31.13l-.26.26a.44.44 0 0 0 0 .62L8.12 9l-3 3a.43.43 0 0 0-.12.3c0 .12.05.23.13.31l.26.26c.08.08.2.13.3.13.13 0 .24-.05.32-.13L9 9.88l3 3a.43.43 0 0 0 .62 0l.25-.27c.08-.08.13-.2.13-.3a.44.44 0 0 0-.13-.32L9.88 9Z"
    />
    <defs>
      <linearGradient id="paint0_linear_0_1" x1="0" x2="18" y1="9" y2="9" gradientUnits="userSpaceOnUse">
        <stop offset=".43" stop-color="#FF7F00" />
        <stop offset="1" stop-color="#EEA823" />
      </linearGradient>
    </defs>
  </g>
  <g id="transparent-background" box="60 60">
    <path fill="#1C1C28" d="M0 0h10v10H0z" />
    <path fill="#2A2A39" d="M10 0h10v10H10z" />
    <path fill="#1C1C28" d="M20 0h10v10H20z" />
    <path fill="#2A2A39" d="M30 0h10v10H30z" />
    <path fill="#1C1C28" d="M40 0h10v10H40z" />
    <path fill="#2A2A39" d="M50 0h10v10H50z" />
    <path fill="#1C1C28" d="M0 20h10v10H0z" />
    <path fill="#2A2A39" d="M10 20h10v10H10z" />
    <path fill="#1C1C28" d="M20 20h10v10H20z" />
    <path fill="#2A2A39" d="M30 20h10v10H30z" />
    <path fill="#1C1C28" d="M40 20h10v10H40z" />
    <path fill="#2A2A39" d="M50 20h10v10H50z" />
    <path fill="#1C1C28" d="M0 40h10v10H0z" />
    <path fill="#2A2A39" d="M10 40h10v10H10z" />
    <path fill="#1C1C28" d="M20 40h10v10H20z" />
    <path fill="#2A2A39" d="M30 40h10v10H30z" />
    <path fill="#1C1C28" d="M40 40h10v10H40z" />
    <path fill="#2A2A39" d="M50 40h10v10H50z" />
    <path fill="#1C1C28" d="M10 10h10v10H10z" />
    <path fill="#2A2A39" d="M0 10h10v10H0z" />
    <path fill="#1C1C28" d="M30 10h10v10H30z" />
    <path fill="#2A2A39" d="M20 10h10v10H20z" />
    <path fill="#1C1C28" d="M50 10h10v10H50z" />
    <path fill="#2A2A39" d="M40 10h10v10H40z" />
    <path fill="#1C1C28" d="M10 30h10v10H10z" />
    <path fill="#2A2A39" d="M0 30h10v10H0z" />
    <path fill="#1C1C28" d="M30 30h10v10H30z" />
    <path fill="#2A2A39" d="M20 30h10v10H20z" />
    <path fill="#1C1C28" d="M50 30h10v10H50z" />
    <path fill="#2A2A39" d="M40 30h10v10H40z" />
    <path fill="#1C1C28" d="M10 50h10v10H10z" />
    <path fill="#2A2A39" d="M0 50h10v10H0z" />
    <path fill="#1C1C28" d="M30 50h10v10H30z" />
    <path fill="#2A2A39" d="M20 50h10v10H20z" />
    <path fill="#1C1C28" d="M50 50h10v10H50z" />
    <path fill="#2A2A39" d="M40 50h10v10H40z" />
  </g>
  <g id="circle_remove" box="20 20">
    <circle cx="10" cy="10" r="10" fill="#353B50" />
    <path
      fill="#fff"
      d="M13.67 7.44h-1.34v-.8c0-.35-.3-.64-.66-.64H8.33a.65.65 0 0 0-.66.64v.8H6.33a.33.33 0 0 0-.33.32v.32c0 .04.04.08.08.08h.63l.26 5.23c.02.34.31.61.67.61h4.72c.36 0 .65-.27.67-.61l.26-5.23h.63c.04 0 .08-.04.08-.08v-.32a.33.33 0 0 0-.33-.32Zm-2.09 0H8.42v-.72h3.16v.72Z"
    />
  </g>
</svg>
